import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';

import {
  canEditNotJoinedPatient,
  canEditPatient,
  targetUserSelector,
} from '../../../redux/context/selectors';
import {
  selectEditedUserSucceed,
  selectEditPatientSuccess,
  selectProfileEditable,
} from '../../../redux/profiles/selectors';
import {
  selectNameSuffixesList,
  selectGenderTypes,
  selectMaritalStatus,
  selectLanguageTypes,
  selectCountryOptions,
  selectRaceTypes,
  selectEthnicTypes,
  selectRelationList,
  selectGenderIdentityList,
  selectVeteranStatusesList,
  selectEducationLevelsList,
  selectCitizinship,
  selectSsnHidingEnabled,
} from '../../../redux/data/selectors';
import { actions as editPatientActions } from '../../../redux/profiles/edit-patient';
import { actions as editUserActions } from '../../../redux/profiles/edit-user';
import styles from '../index.styl';

const mapStateToProps = state => ({
  profile: targetUserSelector(state),
  rawGenderList: selectGenderTypes(state),
  rawMaritalStatusList: selectMaritalStatus(state),
  languageList: selectLanguageTypes(state),
  nameSuffixList: selectNameSuffixesList(state),
  canEdit: canEditPatient(state),
  canEditPatient: canEditNotJoinedPatient(state),
  profileEditable: selectProfileEditable(state),
  countryList: selectCountryOptions(state),
  isSucceedUpdate: selectEditedUserSucceed(state),
  isSucceedPatientUpdate: selectEditPatientSuccess(state),
  rawRaceList: selectRaceTypes(state),
  rawEthnicityList: selectEthnicTypes(state),
  relationList: selectRelationList(state),
  rawGenderIdentityList: selectGenderIdentityList(state),
  veteranStatusesList: selectVeteranStatusesList(state),
  educationLevelsList: selectEducationLevelsList(state),
  citizenship: selectCitizinship(state),
  ssnHidingEnabled: selectSsnHidingEnabled(state),
});

const mapDispatchToProps = {
  savePatient: editPatientActions.send,
  saveUser: editUserActions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ profileErrors }) => {
    return { errors: get(profileErrors, 'meta.validationErrors') };
  }),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/PatientProfile/enhance.js